import { c as _c } from "react/compiler-runtime";
import GroupCreateIncludeMe from "./GroupCreateIncludeMe";
import GroupCreatePrivate from "./GroupCreatePrivate";
export default function GroupCreateIncludeMeAndPrivate(t0) {
  const $ = _c(9);
  const {
    isPrivate,
    setIsPrivate,
    iAmIncluded,
    setIAmIncluded
  } = t0;
  let t1;
  if ($[0] !== iAmIncluded || $[1] !== setIAmIncluded) {
    t1 = <GroupCreateIncludeMe iAmIncluded={iAmIncluded} setIAmIncluded={setIAmIncluded} />;
    $[0] = iAmIncluded;
    $[1] = setIAmIncluded;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== isPrivate || $[4] !== setIsPrivate) {
    t2 = <GroupCreatePrivate isPrivate={isPrivate} setIsPrivate={setIsPrivate} />;
    $[3] = isPrivate;
    $[4] = setIsPrivate;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = <div className="tw-p-3 sm:tw-p-5 tw-bg-iron-950 tw-rounded-xl tw-shadow tw-border tw-border-solid tw-border-iron-800 tw-inline-flex tw-items-center tw-space-x-8">{t1}{t2}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}